import { render, staticRenderFns } from "./ServidorPublicoMG.vue?vue&type=template&id=1513b022"
import script from "./ServidorPublicoMG.vue?vue&type=script&lang=js"
export * from "./ServidorPublicoMG.vue?vue&type=script&lang=js"
import style0 from "./ServidorPublicoMG.vue?vue&type=style&index=0&id=1513b022&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports